import React from 'react';
import { Tag } from 'antd';

interface MethodTagInterface {
    method: string
}

const methodColorMap: any = {
    'POST': 'orange',
    'GET': 'green',
    'PATCH': 'blue',
    'PUT': 'blue',
    'DELETE': 'red',
}

export const MethodTag: React.FC<MethodTagInterface> = ({ method }) => {
    return <Tag color={methodColorMap[method] || 'blue'}>{method}</Tag>
}